"use strict";var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;var _objectSpread2 = _interopRequireDefault(require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime-corejs2/helpers/objectSpread2"));















































































var _vuex = require("vuex"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)({ username: 'getUsername' })), components: {}, data: function data() {return { tableData: [], // 列表数据
      searchData: { page: 1, // 当前页码
        rows: 10 // 页码条数
      }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, newadd: false, title: '新增', addData: { appVersionId: '', languageCode: '', notice: '' }, defaultData: { appVersionId: '', languageCode: '', notice: '' }, rules: { appVersionId: [{ required: true, message: '请输入app版本Id', trigger: 'blur' }], languageCode: [{ required: true, message: '语言code', trigger: 'blur' }], notice: [{ required: true, message: '提示语', trigger: 'blur' }] }, delIds: '' };}, mounted: function mounted() {var self = this;self.searchData.appVersionId = self.$route.params.parentId;self.defaultData.appVersionId = self.$route.params.parentId;self.addData.appVersionId = self.$route.params.parentId;self.init();}, methods: { init: function init() {var self = this;self.getData('/api/faAppVersionInt', self.searchData, function (res) {self.tableData = res.list;self.pageData.page = res.pageNum;self.pageData.total = res.total;});}, handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;this.searchData.page = 1;this.init();}, handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;this.init();}, onCencal: function onCencal() {this.newadd = false;this.$refs['addForm'].resetFields();}, delMenu: function delMenu(item) {var self = this;
      self.$confirm('确定删除该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        self.delData('/api/faAppVersionInt/' + item.id, {}, function (res) {
          self.$message({
            message: '删除成功!',
            type: 'success' });

          self.searchData.page = 1;
          self.init();
        });
      }).catch(function () {});
    },
    addFun: function addFun() {// 新增
      this.title = '新增';
      this.addData = JSON.parse(JSON.stringify(this.defaultData));
      this.newadd = true;
    },
    closeRefund: function closeRefund(done) {// 重置新增列表
      this.$refs['addForm'].resetFields();
      done();
    },
    onSubmit: function onSubmit(item) {
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          self.addData.details = self.poplistData;
          self.postData('/api/faAppVersionInt', {
            appVersionId: self.$route.params.parentId,
            languageCode: self.addData.languageCode,
            notice: self.addData.notice },
          function (res) {
            self.$message({
              message: '新增成功!',
              type: 'success' });

            self.onCencal();
            self.searchData.page = 1;
            self.init();
          });
        } else {
          return false;
        }
      });
    },
    updateMenu: function updateMenu(item) {
      this.title = '编辑';
      var self = this;
      this.addData = {
        id: item.id,
        appVersionId: item.appVersionId,
        languageCode: item.languageCode,
        notice: item.notice };

      self.newadd = true;
    },
    onUpdate: function onUpdate(item) {
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          self.addData.details = self.poplistData;
          self.postData('/api/faAppVersionInt/' + self.addData.id, {
            appVersionId: self.$route.params.parentId,
            languageCode: self.addData.languageCode,
            notice: self.addData.notice },
          function (res) {
            self.$message({
              message: '新增成功!',
              type: 'success' });

            self.onCencal();
            self.searchData.page = 1;
            self.init();
          });
        } else {
          return false;
        }
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {var _this = this;
      this.delIds = '';
      val.map(function (item) {
        _this.delIds += item.id + ',';
      });
    },
    returnFun: function returnFun() {
      // 返回上一级
      this.$router.push('/edition/editionlist');
    } } };exports.default = _default;